import { ReactNode } from "react";

import Box from "ds/components/Box";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";
import PageInfoHeaderActions from "ds/components/PageInfoHeader/Actions";

import { StripeSubscriptionStatus } from "../types";
import BillingSubscriptionStatusBadge from "../components/SubscriptionStatusBadge";

type BillingSubscriptionManagementLayoutProps = {
  children: ReactNode;
  actions: ReactNode;
  subscriptionStatus: StripeSubscriptionStatus;
};

const BillingSubscriptionManagementLayout = ({
  children,
  actions,
  subscriptionStatus,
}: BillingSubscriptionManagementLayoutProps) => {
  return (
    <Box direction="column" grow="1">
      <PageInfoHeaderWrapper>
        <Box gap="medium" align="center">
          <PageInfoHeaderTitle title="Subscription" />
          <BillingSubscriptionStatusBadge status={subscriptionStatus} />
        </Box>
        <PageInfoHeaderActions>
          <Box align="center">{actions}</Box>
        </PageInfoHeaderActions>
      </PageInfoHeaderWrapper>
      <Box direction="column" grow="1" padding="x-large" limitWidth="medium">
        {children}
      </Box>
    </Box>
  );
};

export default BillingSubscriptionManagementLayout;
